import api, { AxiosExceptUrl } from './api'
import { ReportAPI } from 'api'

export const createReports = (...args: AxiosExceptUrl) => {
  return api.post<any>('/reports', ...args)
}

export const getReport = (
  id: string,
  ...args: AxiosExceptUrl<typeof api.get>
) => {
  return api.get<ReportAPI.ReportResponse>(`/reports/${id}`, ...args)
}

export const editReport = (id, ...args: AxiosExceptUrl<typeof api.put>) => {
  return api.put<any>(`/reports/${id}`, ...args)
}

export const deleteReport = (
  id,
  ...args: AxiosExceptUrl<typeof api.delete>
) => {
  return api.delete<any>(`/reports/${id}`, ...args)
}

export const uploadFile = (...args: AxiosExceptUrl) => {
  return api.post<any>('/upload_file', ...args)
}

export const deleteFile = (id, ...args: AxiosExceptUrl<typeof api.delete>) => {
  return api.delete(`/upload_file/${id}`, ...args)
}

export const getSelection = () => {
  return api.get<any>('/reports/selections')
}

export type actions =
  | 'report'
  | 'send-to-reviewer'
  | 'send-to-board'
  | 'hand-over-to-KPK'
  | 'return-to-user'
  | 'archive'
  | 'send-to-investigator'
  | 'return-to-verificator'
  | 'update-suspects'
  | 'verdict'
  | 'finish'

export const reportAction = (
  id: string | number,
  action: actions,
  ...args: AxiosExceptUrl
) => {
  return api.post<any>(`/reports/${id}/${action}`, ...args)
}
